import { FormattedMessage } from 'react-intl'

import Box from 'app/components/base/Box'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'
import { useGetBlogArticles } from 'app/services/Query/blog/blog.query'
import { getFeaturedArticlesQueryParams } from 'app/utils/helpers/blog.helpers'

import LeftSideArticles from './components/LeftSideArticles'
import RightSideArticles from './components/RightSideArticles'

const placeholderArticles = [
  { id: '1' },
  { id: '2' },
  { id: '3' },
  { id: '4' }
] as BlogArticleModel[]

interface FeaturedArticlesProps {
  isMobile?: boolean
  isLoading?: boolean
}

const FeaturedArticles: RFC<FeaturedArticlesProps> = ({
  isMobile,
  isLoading
}) => {
  const params = getFeaturedArticlesQueryParams()

  const { data, isPlaceholderData } = useGetBlogArticles({
    params,
    options: {
      placeholderData: {
        articles: placeholderArticles,
        pagy: {},
        articles_count: placeholderArticles.length
      }
    }
  })

  const [firstArticle, ...restArticles] = data?.articles ?? []

  const hasMoreThanOneArticle = Number(data?.articles?.length) > 1
  const isFeaturedLoading = isLoading || isPlaceholderData

  if (!firstArticle) return null

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 500, md: 'auto' },
        maxWidth: { xs: 375, sm: '100%' },
        mx: 'auto'
      }}
    >
      <Text component="h2" typography={{ xs: 'h3', lg: 'h2' }} sx={{ mb: 3 }}>
        <FormattedMessage defaultMessage="Featured Articles" />
      </Text>

      <Stack
        sx={{
          flexWrap: 'wrap',
          flexDirection: 'row',
          columnGap: { xs: 0, sm: 3.75 },
          rowGap: { xs: 3.75, lg: 0 },
          ...(!hasMoreThanOneArticle && { justifyContent: 'center' })
        }}
      >
        <LeftSideArticles
          article={firstArticle}
          isMobile={isMobile}
          loading={isFeaturedLoading}
        />

        {hasMoreThanOneArticle && (
          <RightSideArticles
            loading={isFeaturedLoading}
            isMobile={isMobile}
            articles={restArticles}
          />
        )}
      </Stack>
    </Box>
  )
}

export default FeaturedArticles
